const th = {
  language: {
    zh: '中文',
    en: 'English',
    id: 'Indonesia',
    th: 'ภาษาไทย'
  },
  dialog: {
    tips: 'ข้อความแจ้งเตือน',
    confirm: 'ยืนยัน',
    cancel: 'ยกเลิก',
  },
  error: {
    tips_1: 'บริการขัดข้อง',
    tips_2: 'ดูเหมือนว่าหาแหล่งข้อมูลไม่พบ',
    tips_3: 'การดำเนินการล้มเหลว โปรดติดต่อผู้ขาย',
  },
  bindings: {
    deviceBinding: 'การผูกอุปกรณ์',
    tips: 'ข้อความแจ้งเตือน',
    tipsContent: 'สแกนหรือป้อนหมายเลขอุปกรณ์เพื่อผูกอุปกรณ์ ตรวจสอบปริมาณการใช้งานได้ตลอดเวลา',
    device: 'หมายเลขอุปกรณ์',
    deviceTips: 'โปรดป้อนหมายเลขอุปกรณ์',
    searchHistory: 'ประวัติการค้นหา',
    searches: 'รายการ',
    binding: 'ผูก',
    imeiTips: 'โปรดป้อนหมายเลขอุปกรณ์'
  },
  xinXunIndex: {
    deviceManagement: 'การจัดการอุปกรณ์',
    onlineDevice: 'อุปกรณ์ออนไลน์',
    currentNetwork: 'เครือข่ายปัจจุบัน',
    signalStrength: 'ความแรงสัญญาณ',
    online: 'ออนไลน์',
    offline: 'ออฟไลน์แล้ว',
    switchingDevices: 'เปลี่ยนอุปกรณ์',
    daysRemaining: 'จำนวนวันคงเหลือ',
    usedData: 'อินเตอร์เน็ตที่ถูกใช้ไปแล้ว',
    toady: "ปริมาณการใช้งานวันนี้",
    total: 'ปริมาณทั้งหมด',
    rechargeAndPay: 'เติมเงิน/ชำระเงิน',
    myPackage: 'แพ็กเกจของฉัน',
    customerService: 'บริการลูกค้า',
    change: 'การเปลี่ยนชื่อ/รหัสผ่าน',
    hotspotName: 'ชื่อฮอตสปอต',
    password: 'รหัสผ่าน WIFI',
    saveChanges: 'บันทึกการแก้ไข',
    status: 'สถานะ',
    language: 'ภาษา',
    wifiName: 'ชื่อเว้นว่างไม่ได้',
    wifiPassword: 'ชื่อเว้นว่างไม่ได้',
    wifiTips: 'โปรดรีสตาร์ทอุปกรณ์หลังจากแก้ไขสำเร็จ การแก้ไขบัญชีและรหัสผ่านจากระยะไกลต้องรอ 3-5 นาที โปรดรอสักครู่',
  },
  usage: {
    myPackage: 'แพ็กเกจของฉัน',
    currentPackage: 'แพ็กเกจปัจจุบัน',
    packageRenewalHistory: 'แพ็กเกจต่ออายุที่ผ่านมา',
    rechargeAndPay: 'เติมเงิน/ชำระเงิน',
    effectiveDate: 'วันที่เริ่มใช้งาน',
    expirationDate: 'วันที่หมดอายุ',
    useData: 'ปริมาณการใช้งานแพ็กเกจปัจจุบัน',
    orderNumber: 'หมายเลขคำสั่งซื้อ',
    received: 'ได้รับแล้ว',
    processing: 'ยังไม่ได้รับ',
    unknown: 'ไม่ทราบ'
  },
  planList: {
    home: 'หน้าแรก',
    packageList: 'รายการแพ็กเกจ',
    monthlyAverage: 'เฉลี่ยต่อเดือน',
    validityPeriod: 'วันหมดอายุ',
    days: 'วัน',
    unlimited: 'ไม่จำกัด',
    longTerm: 'ใช้ได้ระยะยาว',
    tips_1: 'อุปกรณ์นี้ยังไม่มีแพ็กเกจเติมเงิน โปรดติดต่อฝ่ายบริการลูกค้าของร้านค้า',
    tips_2: 'อุปกรณ์นี้ยังไม่มีแพ็กเกจเติมเงิน โปรดติดต่อเจ้าหน้าที่บริการลูกค้าเพื่อดำเนินการ',
    newUserOffer: 'ข้อเสนอใหม่'
  },
  packageDetails: {
    packageDetails: 'รายละเอียดแพ็กเกจ',
    data: 'ปริมาณอินเทอร์เน็ต',
    packageDescription: 'รายละเอียดแพ็กเกจ',
    rechargeNow: 'เติมเงินทันที'
  },
  recharge: {
    payNow: 'ชำระเงินทันที',
    unit: '฿',
    paymentMethod: 'ช่องทางการชำระเงิน',
    onlinePayment: 'ชำระเงินออนไลน์',
    alipayPayment: 'การชำระเงิน Alipay',
    weChatPayment: 'แชทเพย์',
    effectiveDate: 'วันที่เริ่มใช้งาน',
    activateNow: 'เริ่มใช้งานทันที',
    selectDate: 'ระบุวันที่',
    createOrderTip: 'ในการสร้างคำสั่งซื้อโปรดรอ'
  },
  qrCode: { 
    tips_1: 'คุณต้องให้สิทธิ์การเข้าถึงกล้อง',
    tips_2: 'อุปกรณ์นี้ไม่มีกล้อง',
    tips_3: 'กล้องถูกใช้งาน',
    tips_4: 'การติดตั้งกล้องไม่เหมาะสม',
    tips_5: 'เบราว์เซอร์นี้ไม่รองรับ Streaming API',
    tips_6: 'บริบทความปลอดภัยที่ต้องการ (HTTPS, โฮสต์ภายใน)',
  },
  toast: {
    loading: 'กำลังโหลด ..'
  }
}
export default th